export default {
  enums: [
    { id: 'PRINTABLE' },
    { id: 'GLUEABLE' },
    { id: 'MOUNTABLE' },
  ]
};